/*
 * Jira Ticket:
 * Created Date: Thu, 26th Mar 2020, 10:43:48 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import {
  Datagrid,
  DateField,
  List,
  SelectField,
  TextField,
  useTranslate,
  usePermissions,
  Title,
} from 'react-admin';
import { AccessDenied } from 'Layout';
import { isSuperAdmin } from 'utils/roles';
import ListActions from './actions';
import { activeInActiveOptions } from 'utils/choices';
import { PostPagination } from '../../Components/CustomPagination/pagination';

const CountQuestionsArray = ({ record }) => {
  const { questions } = record;
  if (questions && questions.length > 0) {
    return questions.length;
  }
  return 0;
};

const TowerTypeList = props => {
  const translate = useTranslate();
  const { permissions } = usePermissions();
  return isSuperAdmin(permissions) ? (
    <>
      <Title title={`resources.General.cmsTitle`} />
      <List
        title={translate('resources.TowerType.name', { smart_count: 2 })}
        bulkActionButtons={false}
        pagination={<PostPagination />}
        perPage={25}
        actions={<ListActions />}
        {...props}
      >
        <Datagrid rowClick="edit">
          <TextField
            source="name"
            label={translate('resources.TowerType.name', { smart_count: 1 })}
            sortable={false}
          />
          <CountQuestionsArray
            label={'resources.TowerType.fields.questions'}
            sortable={false}
            {...props}
          />
          <DateField
            source="updatedAt"
            label={'resources.TowerType.fields.lastUpdated'}
            sortable={false}
          />
          <SelectField
            source="status"
            choices={activeInActiveOptions}
            label={'resources.TowerType.fields.status'}
            sortable={false}
          />
        </Datagrid>
      </List>
    </>
  ) : (
    <AccessDenied />
  );
};

export default TowerTypeList;
